import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface EmployeeRates {
  id: string;
  hourly_cost_rate: number | null;
  hourly_sales_rate: number | null;
  hire_date: string | null;
}

export function useEmployeeRates() {
  return useQuery({
    queryKey: ["employee-rates"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_employee_rates");
      if (error) throw error;
      return new Map<string, EmployeeRates>(
        (data ?? []).map((r: EmployeeRates) => [r.id, r])
      );
    },
    staleTime: 5 * 60 * 1000,
  });
}
